export default __webpack_public_path__ + "static/media/icono-suma-asegurada.bd984501.svg";